const pages: Page[] = [
  {
    id: "home",
    icon: "mdi-desktop-mac",
    text: "Página Inicial",
    link: { name: "home" }
  },
  /*
  {
    id: "agency",
    icon: "mdi-youtube-subscription",
    text: "Agências",
    link: { name: "agencies" }
  },
  {
    id: "advertiser",
    icon: "mdi-account-group-outline",
    text: "Anunciantes",
    link: { name: "advertisers" }
  },
  */
  {
    id: "profile",
    icon: "mdi-account-circle-outline",
    text: "Perfil",
    subMenus: true,
    isOpen: false,
    items: [
      {
        id: "company",
        icon: "mdi-home-city-outline",
        text: "Minha empresa",
        link: { name: "company" }
      },
      {
        id: "users",
        icon: "mdi-account-group-outline",
        text: "Usuários",
        link: { name: "users" }
      }
    ]
  },
  {
    id: "midia-kit",
    icon: "mdi-camera-burst",
    text: "Programas",
    external: true,
    link: "https://sbtnegocios.com.br/midia/programas"
  },
  {
    id: "help",
    icon: "mdi-help",
    text: "Ajuda",
    link: { name: "help" }
  },
  {
    id: "logout",
    icon: "mdi-close-circle-outline",
    text: "Sair",
    link: { name: "logout" }
  }
];

const statusColors = {
  DRAFT: "#5580EE",
  AWAITING_MIDIA: "#FF2828",
  REJECTED_PAYMENT: "#FF2828",
  CANCELLED_PAYMENT: "#FF2828",
  PENDING_PAYMENT: "#ff8e0c",
  IN_PROCESS_PAYMENT: "#ff8e0c",
  IN_MEDIATION_PAYMENT: "#ff8e0c",
  WAITING_PAYMENT: "#ff8e0c",
  SETTLED_PAYMENT: "#5BBA67",
  APPROVED_PAYMENT: "#5BBA67",
  AUTHORIZED_PAYMENT: "#5BBA67",
  IN_ANALYSIS_PAYMENT: "#8D8787",
  REFUNDED_PAYMENT: "#8D8787",
  CHARGED_BACK_PAYMENT: "#8D8787",
  DONE: "#8D8787"
};

const state: StateObj = {
  updatedAreaName: "",
  globalAlert: {},
  globalLoading: true,
  statusColors,
  pages
};

export default { ...state };
